<h2 class="text-body-lg-500 text-primary-500 mb-2 font-title">Lot Setup</h2>

@if (hasViolations()) {
  <p-message severity="warn" icon="pi pi-exclamation-triangle" styleClass="mb-3 w-full">
    <div class="flex flex-col gap-1">
      <span class="font-semibold">{{ violatedRules().length }} Rule(s) Violated</span>
      <ul class="list-disc pl-5 m-0">
        @for (rule of violatedRules(); track rule) {
          <li class="text-body-xs">{{ rule }}</li>
        }
      </ul>
    </div>
  </p-message>
}

<div class="grid grid-cols-1 sm:!grid-cols-3 gap-x-4 gap-y-5" [formGroup]="form">
  <!-- Lot Type -->
  <div class="flex flex-col">
    <p-floatlabel variant="on">
      <generic-dropdown
        [items]="lotTypesDropdownData()"
        [label]="''"
        [placeholder]="''"
        [required]="true"
        [allowSearch]="true"
        [clearable]="true"
        [formControl]="lotTypeControl"
      ></generic-dropdown>
      <label class="text-red-500 text-body-xs">Lot type</label>
    </p-floatlabel>

    @if (form.controls.lotType.touched && form.controls.lotType.invalid) {
      <span class="text-red-500 text-body-xs">Lot Type is required.</span>
    }
  </div>

  <!-- Model -->
  <div class="flex flex-col">
    <p-floatlabel variant="on">
      <generic-dropdown
        [items]="modelsDropdownData()"
        [label]="''"
        [placeholder]="''"
        [required]="!isLotTypeReg()"
        [allowSearch]="true"
        [clearable]="true"
        [formControl]="modelControl"
      ></generic-dropdown>
      <label class="text-red-500 text-body-xs">Model</label>
    </p-floatlabel>
    @if (modelControl.touched && modelControl.invalid) {
      <span class="text-red-500 text-body-xs">Model is required.</span>
    }
  </div>

  <!-- Elevation -->
  <div class="flex flex-col">
    <p-floatlabel variant="on">
      <generic-dropdown
        [items]="elevationsDropdownData()"
        [label]="''"
        [placeholder]="''"
        [required]="!isLotTypeReg()"
        [allowSearch]="true"
        [clearable]="true"
        [formControl]="elevationControl"
      ></generic-dropdown>
      <label class="text-red-500 text-body-xs">Elevation</label>
    </p-floatlabel>
    @if (elevationControl.touched && elevationControl.invalid) {
      <span class="text-red-500 text-body-xs">Elevation is required.</span>
    }
  </div>
</div>
